module.exports = __webpack_public_path__ + "static/media/resume.b2c983cc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/documents/resume.pdf
// module id = 336
// module chunks = 0